import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "../styles/linkbuilding_4.css";

handleFloatingPromise(initExpertSite());
